import * as api from './api';
import { Setting, Request } from '../';
import { sleep } from '@yichui/js-contrib/src/utils';

// 防并发请求
let doing_user = false; //

//
const state = {
  msgUser: {}, // 模块用户信息
  totalUnRead: 0, // 总的未读消息数
  recentUnRead: 0, // 总的未读最近联系人数
  recentList: [], // 最近会话列表
  recentListMeta: null,
};

//
const mutations = {
  updateState(state, payload) {
    const keys = Object.keys(payload);
    keys.forEach(key => {
      state[key] = payload[key];
    });
  },
  SET_MSG_USER: (state, data) => {
    state.msgUser = Object.assign({}, data);
  },
};

//
const actions = {
  // 我的信息
  async msgUser({ state, commit }, params) {
    if (doing_user) {
      // 并发等结果
      while (doing_user) {
        await sleep(50);
        console.log('[debug-sleep] msgUser');
      }
    } else {
      //
      try {
        doing_user = true;
        //
        const data = await api.msgUser(params);
        console.log('[debug-msgUser]');
        if (data) {
          commit('SET_MSG_USER', data);
        }
        commit('updateState', {
          totalUnRead: data.unread ? data.unread : 0,
          recentUnRead: data.unreadTiny ? data.unreadTiny : 0,
        });
      } catch (err) {
        // 未知错误
        // console.error(`msgUser`, err);
        commit('SET_MSG_USER', {});
      } finally {
        doing_user = false;
      }
    }
    console.log('[debug-msgUser-return]');
    return state.msgUser;
  },

  // 获取最近会话总的未读消息数量
  async getRecents({ commit }, params) {
    const { data, meta } = await api.queryRecentList(params);
    commit('updateState', {
      recentList: data,
      recentListMeta: meta,
    });
    // console.log('%c [totalUnRead >>> ]: ', 'color:#1989fa;', totalUnRead);
    return data;
  },
};

//
const getters = {};

//
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
